import React from 'react';
import { useWatch } from 'react-hook-form';

import PropTypes from 'prop-types';

import InputField from '../InputField';
import PasswordStrengthMeter from './PasswordStrengthMeter';

// strengthInputs is an array of values that, if used to derive the password, will
// negatively impact the score of that password. For example, if a user uses their email
// as a part of their password, the score will be lower if the email is included in the
// strengthInputs array.
const PasswordStrengthField = ({
  control,
  label = 'Password',
  name = 'password',
  strengthInputs = [],
}) => {
  // Track the field's live value so that the <PasswordStrengthMeter /> updates as the
  // user types.
  const password = useWatch({ control, name });

  return (
    <div className="flex flex-col gap-3">
      <InputField control={control} label={label} name={name} type="password" />
      <PasswordStrengthMeter password={password} strengthInputs={strengthInputs} />
    </div>
  );
};

PasswordStrengthField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  strengthInputs: PropTypes.arrayOf(PropTypes.string),
};

export default PasswordStrengthField;
